import { authRoles } from 'app/auth/authRoles';
import Loadable from 'app/components/Loadable';
import { lazy } from 'react';

const ChargerAnalytics = Loadable(lazy(() => import('./ChargerAnalytics')));
const chargerRoutes = [
  { path: '/charger/default', element: <ChargerAnalytics />, auth: authRoles.admin },
];
export default chargerRoutes;
